
const fields = [
    {
        type: "bsx-input",
        inputType: "text",
        label: "標題",
        model: "title",
        required: true,
        validator: function () {
            this.validation();
        },
    },
    {
        type: "bsx-upload",
        label: "封面截圖",
        model: "cover_img",
        kind: "button",
        required: true,
        browse: true,
        preview: true,
        accept: ".jpg,.png",
        folder: "diagnosis_and_treatment",
        validator: function () {
            this.validation();
        },
    },
    {
        type: "x-QuillEditor",
        label: "診療內容",
        model: "content",
        required: true,
        validator: function () {
            this.validation();
        },
    },
    {
        type: 'bsx-toggle',
        label: '是否顯示',
        model: 'is_show',
        required: true,
        textOn: '是',
        textOff: '否',
        valueOn: 1,
        valueOff: 0,
    },
    {
        type: "bsx-input",
        inputType: "number",
        label: "權重",
        model: "sort",
        required: true,
        validator: function () {
            this.validation();
        },
    },
];

export default fields;
